import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CardSortOrderSetting as SchemaCardSortOrderSetting } from '../schemas/CardSortOrderSetting';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const PatchProductsCardSortOrderSettingsContentType = 'application/json' as const;
export type PatchProductsCardSortOrderSettingsRequest = SchemaCardSortOrderSetting;
export type PatchProductsCardSortOrderSettingsResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': SchemaCardSortOrderSetting;
    };
};
export type PatchProductsCardSortOrderSettingsResponseSuccess =
    PatchProductsCardSortOrderSettingsResponses['200']['application/json'];
export type PatchProductsCardSortOrderSettingsSearchParams = undefined;
export type PatchProductsCardSortOrderSettingsPathParameters = undefined;
export const PatchProductsCardSortOrderSettingsUrl = '/products/settings/card_sort_order' as const;
export const PatchProductsCardSortOrderSettingsMethod = 'PATCH' as const;
export const getPatchProductsCardSortOrderSettingsUrl = (_params?: PatchProductsCardSortOrderSettingsPathParameters) =>
    PatchProductsCardSortOrderSettingsUrl;
